import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL, FILL_OPERDON_SOME_RECORE } from "../../constant-value";
import api from "../../services/axiosConfig";


export const getLastOperdon = createAsyncThunk("operdonListCard/getLastOperdon", async () => {
  try {
      const response = await api.get(`/${FILL_OPERDON_SOME_RECORE}`);
      // const response = await axios.get(`${BASE_URL}/${FILL_OPERDON_SOME_RECORE}`);
      return response.data.operdones;
  } catch (error) {
    console.error(error);
  }
});

const defaultValue = [];

const operdonSlice = createSlice({
  name: "operdonListCard",
  initialState: {
    operdons: defaultValue,
    isLoading: false,
    hasError: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLastOperdon.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(getLastOperdon.fulfilled, (state, action) => {
        state.operdons = action.payload;
        state.isLoading = false;
        state.hasError = false;
      })
      .addCase(getLastOperdon.rejected, (state, action) => {
        state.isLoading = false;
        state.hasError = true;
      });
  },
});

// Selectors
export const selectOperdons = (state) => state.operdonListCard.operdons;
export const selectLoadingOperdonState = (state) => state.operdonListCard.isLoading;
export const selectErrorOperdonState = (state) => state.operdonListCard.hasError;

export default operdonSlice.reducer;

export const { getOperdons, newoperdon, editOperdon, deleteoperdon } = operdonSlice.actions;
